export default __webpack_public_path__ + "c069f300259b4101f534f67f3af226b2.svg";